import { Product } from "../productsData";

function getAllPoloTShirtsData(): Product[] {
  return [
    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "POLO T-SHIRT",
          path: "/polo-t-shirt",
        },
      ],
      pathName: "cut-and-sew-logo-style-7",
      fullPath: `/polo-t-shirt/product/cut-and-sew-logo-style-7`,
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662481453/shopping%20cart/polo%20t%20shirts/mthpop07-920x815_ucb3q5.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662486095/shopping%20cart/polo%20t%20shirts/product%20card%20image/mthpop07-350x435_by5udw.jpg",
      name: "Cut and Sew Logo Style 7",
      price: "৳ 750.00",
      details: [
        "Regular fit, Shirt collar, Comfortable to wear",
        "220 GSM ",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
        "Single lacoste fabric",
      ],
      size: ["M", "L", "XL", "XXL"],
      fabric: [],
      color: [],
      description: [
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "POLO T-SHIRT",
          path: "/polo-t-shirt",
        },
      ],
      pathName: "cut-and-sew-logo-style-6",
      fullPath: `/polo-t-shirt/product/cut-and-sew-logo-style-6`,
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662481815/shopping%20cart/polo%20t%20shirts/MTHPOCSLSP6-920x920_a3dtxv.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662486124/shopping%20cart/polo%20t%20shirts/product%20card%20image/MTHPOCSLSP6-350x435_lkueub.jpg",
      name: "Cut and Sew Logo Style 6",
      price: "৳ 750.00",
      details: [
        "Regular fit, Shirt collar, Comfortable to wear",
        "220 GSM ",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
        "Single lacoste fabric",
      ],
      size: ["M", "L", "XL", "XXL"],
      fabric: [],
      color: [],
      description: [
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "POLO T-SHIRT",
          path: "/polo-t-shirt",
        },
      ],
      pathName: "cut-and-sew-logo-style-5",
      fullPath: `/polo-t-shirt/product/cut-and-sew-logo-style-5`,
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662481909/shopping%20cart/polo%20t%20shirts/MTHPOCSLSP5-920x920_lvqjax.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662486146/shopping%20cart/polo%20t%20shirts/product%20card%20image/MTHPOCSLSP5-350x435_vf0xl8.jpg",
      name: "Cut and Sew Logo Style 5",
      price: "৳ 750.00",
      details: [
        "Regular fit, Shirt collar, Comfortable to wear",
        "220 GSM ",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
        "Single lacoste fabric",
      ],
      size: ["M", "L", "XL", "XXL"],
      fabric: [],
      color: [],
      description: [
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "POLO T-SHIRT",
          path: "/polo-t-shirt",
        },
      ],
      pathName: "cut-and-sew-logo-style-4",
      fullPath: `/polo-t-shirt/product/cut-and-sew-logo-style-4`,
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662482006/shopping%20cart/polo%20t%20shirts/MTHPOCSLSP4-920x920_yqkba1.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662486160/shopping%20cart/polo%20t%20shirts/product%20card%20image/MTHPOCSLSP4-350x435_wccxh7.jpg",
      name: "Cut and Sew Logo Style 4",
      price: "৳ 750.00",
      details: [
        "Regular fit, Shirt collar, Comfortable to wear",
        "220 GSM ",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
        "Single lacoste fabric",
      ],
      size: ["M", "L", "XL", "XXL"],
      fabric: [],
      color: [],
      description: [
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "POLO T-SHIRT",
          path: "/polo-t-shirt",
        },
      ],
      pathName: "cut-and-sew-logo-style-3",
      fullPath: `/polo-t-shirt/product/cut-and-sew-logo-style-3`,
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662482135/shopping%20cart/polo%20t%20shirts/MTHPOCSLSP3-920x920_an8t0y.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662486174/shopping%20cart/polo%20t%20shirts/product%20card%20image/MTHPOCSLSP3-350x435_cyckjj.jpg",
      name: "Cut and Sew Logo Style 3",
      price: "৳ 750.00",
      details: [
        "Regular fit, Shirt collar, Comfortable to wear",
        "220 GSM ",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
        "Single lacoste fabric",
      ],
      size: ["M", "L", "XL", "XXL"],
      fabric: [],
      color: [],
      description: [
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "POLO T-SHIRT",
          path: "/polo-t-shirt",
        },
      ],
      pathName: "cut-and-sew-logo-style-2",
      fullPath: `/polo-t-shirt/product/cut-and-sew-logo-style-2`,
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662482224/shopping%20cart/polo%20t%20shirts/MTHPOCSLSP2-920x920_oispms.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662486203/shopping%20cart/polo%20t%20shirts/product%20card%20image/MTHPOCSLSP2-350x435_okh6br.jpg",
      name: "Cut and Sew Logo Style 2",
      price: "৳ 750.00",
      details: [
        "Regular fit, Shirt collar, Comfortable to wear",
        "220 GSM ",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
        "Single lacoste fabric",
      ],
      size: ["M", "L", "XL", "XXL"],
      fabric: [],
      color: [],
      description: [
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "POLO T-SHIRT",
          path: "/polo-t-shirt",
        },
      ],
      pathName: "cut-and-sew-logo-style",
      fullPath: `/polo-t-shirt/product/cut-and-sew-logo-style`,
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662482328/shopping%20cart/polo%20t%20shirts/MTHPOCSLSP1-920x920_qy5maj.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662486222/shopping%20cart/polo%20t%20shirts/product%20card%20image/MTHPOCSLSP1-350x435_qfgo2u.jpg",
      name: "Cut and Sew Logo Style 1",
      price: "৳ 750.00",
      details: [
        "Regular fit, Shirt collar, Comfortable to wear",
        "220 GSM ",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
        "Single lacoste fabric",
      ],
      size: ["M", "L", "XL", "XXL"],
      fabric: [],
      color: [],
      description: [
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "POLO T-SHIRT",
          path: "/polo-t-shirt",
        },
      ],
      pathName: "polo-t-shirt-royale-blue",
      fullPath: `/polo-t-shirt/product/polo-t-shirt-royale-blue`,
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662482416/shopping%20cart/polo%20t%20shirts/mthpos-royal-blue-920x815_o12p5x.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662486244/shopping%20cart/polo%20t%20shirts/product%20card%20image/mthpos-royal-blue-350x435_fi19kx.jpg",
      name: "Polo T-Shirt Royale Blue",
      price: "৳ 750.00",
      details: [
        "Regular fit, Shirt collar, Comfortable to wear",
        "220 GSM ",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
        "Single lacoste fabric",
      ],
      size: ["M", "L", "XL", "XXL"],
      fabric: [],
      color: [],
      description: [
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        size: "S, M, L, XL, XXL",
      },
    },
  ];
}

export default getAllPoloTShirtsData;

function getSpecificPoloTShirtData(searchPath: string) {
  return (
    getAllPoloTShirtsData().find((product) => {
      const productPath = product.pathName;
      return productPath === searchPath;
    }) || getAllPoloTShirtsData()[0]
  );
}

export { getSpecificPoloTShirtData };
